import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 0c-1.805 0-3.554.24-5.217.689L13.043 20l1.74 19.311c1.663.448 3.412.689 5.217.689 11.046 0 20-8.954 20-20S31.046 0 20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "m13.043 20 1.74 19.311c1.663.448 3.412.689 5.217.689 11.046 0 20-8.954 20-20H13.043Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M0 20c0 9.24 6.267 17.016 14.783 19.311V.689C6.267 2.984 0 10.759 0 19.999Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "m7.557 14.783 1.295 3.985h4.191l-3.39 2.464 1.295 3.985-3.39-2.463-3.391 2.463 1.295-3.985-3.39-2.464h4.19l1.295-3.985Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function h(_, r) {
  return e(), l("svg", o, [...d]);
}
const u = { render: h };
export {
  u as default,
  h as render
};
